import { useReveal } from "@/hooks/useReveal";

const ROWS = [
  { label: "Default Incoterm", value: "FOB Cartagena or Buenaventura, Colombia" },
  { label: "Alternative Incoterm", value: "CIF to your port of destination, quoted on request" },
  { label: "Container", value: "40 ft container, approximately 20 tonnes" },
  { label: "Minimum order", value: "Half a container as a minimum" },
  { label: "Ports of destination served", value: "Cape Town and Durban" },
  {
    label: "Payment terms, first order",
    value: "Irrevocable confirmed letter of credit, or substantial advance payment",
  },
  {
    label: "Label localisation",
    value:
      "Adapted to South African labelling requirements, agreed with the importer before shipping",
  },
];

export default function Logistics() {
  const headingRef = useReveal<HTMLDivElement>();
  const tableRef = useReveal<HTMLDivElement>();

  return (
    <section id="logistics" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headingRef} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Export terms at a glance
          </h2>
          <p className="mt-4 text-ink/70 text-lg max-w-2xl">
            Everything you need to calculate your landed cost before you reply
            to us.
          </p>
        </div>

        <div ref={tableRef} className="reveal mt-12 bg-white rounded-lg border border-cream-dark/70 overflow-hidden">
          <dl>
            {ROWS.map((row, i) => (
              <div
                key={row.label}
                className={`grid grid-cols-1 md:grid-cols-[280px_1fr] gap-1 md:gap-6 px-6 py-5 ${
                  i % 2 === 0 ? "bg-white" : "bg-cream/40"
                } ${i !== 0 ? "border-t border-cream-dark/50" : ""}`}
              >
                <dt className="text-brown font-semibold text-base">{row.label}</dt>
                <dd className="text-ink/80 text-base leading-relaxed">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}